/**
 * Morphicons 预览页辅助数据（全库浏览仍用 lucide；业务映射见 pm-morph-icon-map.js）。
 */
import {
  PM_MORPH_ICON_MAP_ENTRIES,
  PM_MORPH_ICON_PAIRS,
  getPmMorphIconData,
} from './pm-morph-icon-map.js';
import { lucideIconEntries } from './morphicon-lucide-index.js';

/** 与 PmIcon 对照（来自映射表） */
export const morphiconPmParallels = PM_MORPH_ICON_MAP_ENTRIES.filter((e) => e.pmIcon).map(
  (e) => ({
    name: e.name,
    lucide: e.lucide,
    pm: e.pmIcon,
    desc: e.note,
  }),
);

/** 设计预览：Lucide 全名浏览（非业务用名） */
export const morphiconBrowseIcons = lucideIconEntries.slice(0, 26).map(({ name, data }) => ({
  name,
  data,
  desc: name,
}));

/** 尺寸对照样本（项目名 + 可选 PmIcon） */
export const morphiconSizeCompareIcons = PM_MORPH_ICON_MAP_ENTRIES.filter((e) =>
  ['Search', 'Nav_menu', 'Check', 'Add', 'Link2', 'Arrow_right', 'Edit', 'Download'].includes(e.name),
).map((e) => ({
  name: e.name,
  pm: e.pmIcon || null,
  data: e.data,
}));

/** 形变演示对（项目名） */
export const morphiconDemoPairs = PM_MORPH_ICON_PAIRS.map((pair) => ({
  ...pair,
  pmHint: pair.label,
  offData: getPmMorphIconData(pair.off),
  onData: getPmMorphIconData(pair.on),
}));

export const morphiconSpringPresets = [
  { key: 'snappy', label: 'Snappy', desc: '干脆，适合按钮切换' },
  { key: 'smooth', label: 'Smooth', desc: '柔和过渡' },
  { key: 'bouncy', label: 'Bouncy', desc: '带弹性' },
];
